import { Box } from '@chakra-ui/react';
import ServiceItem from './ServiceItem'; // Assurez-vous que le chemin d'importation est correct
import { ClientServices } from 'types/client';

const ServicesList: React.FC<ClientServices> = ({ services }) => {
  // Les 5 premiers services à afficher en dehors de l'accordéon
  const firstFiveServices = services.slice(0, 4);
  // Les services restants à afficher dans l'accordéon
  // const remainingServices = services.slice(4);

  return (
    <>
      {/* Affichage des 4 premiers services */}
      <Box w="full" padding={'1em'} className="accountServices">
        {firstFiveServices.map((service, index) => (
          <ServiceItem
            key={index}
            title={service.Name}
            remaining={service.Remaining}
            activated={service.ActiveDate}
            expires={service.ExpirationDate}
          />
        ))}
      </Box>

      {/* Affichage de l'accordéon pour les services supplémentaires si nécessaire */}
      {/*
      {remainingServices.length > 0 && (
        <Accordion allowToggle w="full" mt={5}>
          <AccordionItem>
            <AccordionButton>
              <Box flex="1" textAlign="left">
                <Text>Voir tous les crédits actifs</Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel padding={'1em'}>
              {remainingServices.map((service, index) => (
                <ServiceItem
                  key={index}
                  title={service.Name}
                  remaining={service.Remaining}
                  activated={service.ActiveDate}
                  expires={service.ExpirationDate}
                />
              ))}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      )}
      */}
    </>
  );
};

export default ServicesList;
